import { configureStore } from "@reduxjs/toolkit";
import { ToolkitStore } from "@reduxjs/toolkit/dist/configureStore";
import rootReducer from "./reducers/rootReducer";
import reduxStoreWorker from "./reduxStoreWorker";

//const store = configureStore({
//reducer: rootReducer,
//middleware: (getDefaultMiddleware) => getDefaultMiddleware()//.concat(toolkitRaw.createAsyncThunk)
//});

//reduxStoreWorker.setStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
//export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
//export type AppDispatch = typeof store.dispatch

//export default store;

const LOCAL_STORAGE_NAME = "alttime:store";

class PersistedStore {
  // Singleton property
  static DefaultStore: PersistedStore | undefined = undefined;

  // Accessor to the default instance of this class
  static getDefaultStore(): PersistedStore {
    if (PersistedStore.DefaultStore === undefined) {
      PersistedStore.DefaultStore = new PersistedStore();
    }

    return PersistedStore.DefaultStore;
  }

  // Redux store
  _store: ToolkitStore | undefined;

  // When class instance is used, initialize the store
  constructor() {
    this.initStore();
  }

  // Initialization of Redux Store
  initStore() {
    this._store = configureStore({
      reducer: rootReducer,
      preloadedState: PersistedStore.loadState(),
    });
    this._store.subscribe(() => {
      PersistedStore.saveState(this._store?.getState());
    });
  }

  // Getter to access the Redux store
  get store() {
    return this._store;
  }

  // Loading persisted state from localStorage, no need to access
  // this method from the outside
  static loadState() {
    try {
      let serializedState = localStorage.getItem(LOCAL_STORAGE_NAME);

      if (serializedState === null) {
        return PersistedStore.initialState();
      }

      return JSON.parse(serializedState);
    } catch (err) {
      return PersistedStore.initialState();
    }
  }

  // Saving persisted state to localStorage every time something
  // changes in the Redux Store (This happens because of the subscribe()
  // in the initStore-method). No need to access this method from the outside
  static saveState(state: RootState) {
    try {
      let serializedState = JSON.stringify(state);
      localStorage.setItem(LOCAL_STORAGE_NAME, serializedState);
    } catch (err) {}
  }

  // Return whatever you want your initial state to be
  static initialState() {
    return {};
  }
}

const store = PersistedStore.getDefaultStore().store!!;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

reduxStoreWorker.setStore(store);

export default store;
